export const HOME_SERVICES_LIST = [
  {
    image: "images/services_custom_software.webp",
    heading: "Custom Software Dev",
    detail:
      "Cross-platform software development using multiple technologies that suit best as per project nature and requirement for efficiency in both speed and time for desktop, mobile and cloud platform",
    link: "/",
  },
  {
    image: "images/services_ui.webp",
    heading: "UI Design & Prototyping",
    detail:
      "User-centric UI/UX design and prototyping to generate software applications with robust design principles with iteratively updating design as per feedback to increase audience accessability",
    link: "/",
  },
  {
    image: "images/services_web.webp",
    heading: "Web Dev",
    detail:
      "Tailor-made websites using latest technology stacks to deliver high-speed, reliable and user-friendly web applications that work with maximum compatibility and efficiency on all platforms",
    link: "/",
  },
  {
    image: "images/services_mobile.webp",
    heading: "Native Mobile App Dev",
    detail:
      "Speed and memory efficient mobile app development for Android and IOS platforms to provide best user experience using latest technologies and software development techniques",
    link: "/",
  },
  {
    image: "images/services_graphic.webp",
    heading: "Graphic Design",
    detail:
      "Eye-catching and attractive graphic design services including logo design, branding elements and advertisement campaign elements using modern design principles to generate impactful designs ",
    link: "/",
  },
  {
    image: "images/services_3d.webp",
    heading: "3D Design & Modelling",
    detail:
      "Modern tools and techniques to design, model and render 3d models with finest details and realistic views with special effects like sculpting, animation and texturing to create real world 3d designs and models",
    link: "/",
  },
  {
    image: "images/services_game.webp",
    heading: "Game Dev",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_ar_vr.webp",
    heading: "Augmented Reality",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_automation.webp",
    heading: "Automation and QA",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_scrape.webp",
    heading: "Web Scraping",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_database.webp",
    heading: "Databases",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_hybrid.webp",
    heading: "Hybrid App Dev",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_cloud.webp",
    heading: "Cloud DevOps",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_ecommerce.webp",
    heading: "E-Commerce",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_api.webp",
    heading: "API Design & Scaling",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_ai.webp",
    heading: "AI & Machine Learning",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_network.webp",
    heading: "Systems & Network Design",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
  {
    image: "images/services_support.webp",
    heading: "IT Support Service",
    detail:
      "Game design and development with breathtaking storyline, stunning graphics and user-centric plot for providing awesome gameplay experience using latest technologies and techniques ",
    link: "/",
  },
]

export const TECH_STACK_LIST = [
  "images/tech_azure.webp",
  "images/tech_gatsbyjs.webp",
  "images/tech_sql.webp",
  "images/tech_nodejs.webp",
  "images/tech_react.webp",
  "images/tech_css.webp",
  "images/tech_express.webp",
  "images/tech_figma.webp",
  "images/tech_gcp.webp",
  "images/tech_ai.webp",
  "images/tech_html.webp",
  "images/tech_java.webp",
  "images/tech_jquery.webp",
  "images/tech_js.webp",
  "images/tech_kotlin.webp",
  "images/tech_mui.webp",
  "images/tech_mysql.webp",
  "images/tech_nextjs.webp",
  "images/tech_opengl.webp",
  "images/tech_django.webp",
  "images/tech_php.webp",
  "images/tech_ps.webp",
  "images/tech_qt.webp",
  "images/tech_blender.webp",
  "images/tech_bootstrap.webp",
  "images/tech_oracle.webp",
  "images/tech_reactnative.webp",
  "images/tech_cs.webp",
  "images/tech_cpp.webp",
  "images/tech_unity.webp",
  "images/tech_wp.webp",
  "images/tech_xd.webp",
]

export const PORTFOLIO_LIST = [
  {
    clientName: "Deventure Shoes",
    projectType: "E-commerce Website",
    description:
      "Fully responsive and high speed online ecommerce store with inventory management system backed by blazing fast API servers user-friendly UI/UX design.",
    urlPlaceholder: "deventureshoes.com",
    url: "https://deventureshoes.com/",
    img: "images/portfolio_1.webp",
  },
  {
    clientName: "Allahdin Casting Foundry",
    projectType: "Business Website",
    description:
      "Attractive user interface and high speed page routing with responsive design. This project is a business website for a brand.",
    urlPlaceholder: "allahdincastingfoundry.com",
    url: "https://allahdincastingfoundry.com/",
    img: "images/portfolio_2.webp",
  },
  {
    clientName: "TheBookDotCom",
    projectType: "E-commerce Website",
    description:
      "Fully responsive and high speed online book selling website with inventory management system backed by blazing fast API servers user-friendly UI/UX design.",
    urlPlaceholder: "thebookdot.com",
    url: "https://thebookdot.com/",
    img: "images/portfolio_3.webp",
  },
]

export const TEAM_LIST = [
  {
    name: "Syed Faateh Sultan Kazmi",
    role: "Founder, Lead Full Stack Developer",
    img: "/images/team_faateh.webp",
    linkedin: "https://www.linkedin.com/in/faatehsultankazmi/",
    facebook: "https://www.facebook.com/faatehsultan.kazmi",
    github: "https://github.com/faatehsultan",
    mail: "faatehsultan20@gmail.com",
  },
  {
    name: "Omer Sharif Bhatti",
    role: "Full Stack Developer, 3D Artist",
    img: "/images/team_omer.webp",
    linkedin: "https://www.linkedin.com/in/omerbhatti1/",
    facebook: "https://www.facebook.com/omerbha8",
    github: "https://github.com/omerbhatti",
    mail: "omerbhatti34@gmail.com",
  },
  // {
  //   name: "Syed Hammad",
  //   role: "Co-Founder, Marketing Lead",
  //   img: "/images/team_hammad.webp",
  //   linkedin: "https://www.linkedin.com/in/syedhammad865/",
  //   facebook: "https://www.facebook.com/syed.hammad865",
  //   mail: "hammadsyed865@gmail.com",
  // },
  {
    name: "Muhammad Azam",
    role: "UI/UX Designer",
    img: "/images/team_azam.webp",
    linkedin: "https://www.linkedin.com/in/muhammad-azam123/",
    facebook: "https://www.facebook.com/aazam.sultan.71",
    github: "https://github.com/AazamJutt",
    mail: "m.aazasultan@gmail.com",
  },
  {
    name: "Muhammad Bilal",
    role: "Front End Developer",
    img: "/images/team_bilal.webp",
    linkedin: "https://www.linkedin.com/in/muhammadbilal2001/",
    facebook: "https://www.facebook.com/bilaljavedkewl",
    github: "https://github.com/emeraldThug",
    mail: "bilaljavedblackops15@gmail.com",
  },
]
